module.exports = __webpack_public_path__ + "static/media/howtobefat_img_4.ba692ee3.png";